// This file is automatically generated. Do not edit manually.

import { CustomerOrderBillingPlanLineView } from "src/api/generated/erp/db/types/tables/customerOrderBillingPlanLineView";
import { BillingPlanSummary } from "src/api/generated/erp/sales/billingPlan/service/billingPlanSummary";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerOrderBillingPlanApi {
	export async function getCustomerOrderBillingPlan(args: {
		customerOrderId: number;
	}): Promise<CustomerOrderBillingPlanApi_BillingPlanDto> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/billingPlan/getCustomerOrderBillingPlan",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
			},
		});
		return response as CustomerOrderBillingPlanApi_BillingPlanDto;
	}
}

export interface CustomerOrderBillingPlanApi_BillingPlanDto {
	lines: Array<CustomerOrderBillingPlanLineView>;
	summary: BillingPlanSummary;
}
